import { Slider } from "../../../components/ui/slider";
import { Label } from "../../../components/ui/label";
import { Input } from "../../../components/ui/input";
import { publicFileUrl } from "../../../lib/plans";
import { Group, SaveBar, Toggle, UploadField, useDraft, useSectionSave } from "./shared";

const PRESETS = [["Royal gold", "#D4AF37"], ["Champagne", "#E6C79C"], ["Amber", "#F59E0B"], ["Rose gold", "#B76E79"], ["Emerald", "#2E9E6B"], ["Sapphire", "#3B6FD8"], ["Platinum", "#C9CED6"]];

export const ThemeSection = () => {
  const { settings, save, busy } = useSectionSave();
  const [th, setTh] = useDraft(settings.theme);
  const s = (k) => (v) => setTh({ ...th, [k]: v });
  return (
    <div className="space-y-6">
      <Group title="Light / dark mode">
        <div className="flex gap-3">
          {["dark", "light"].map((m) => (
            <button key={m} type="button" onClick={() => s("default_mode")(m)} className={th.default_mode === m ? "btn-gold !py-2" : "btn-ghost-gold !py-2"} data-testid={`theme-default-${m}`}>Default: {m}</button>
          ))}
        </div>
        <Toggle label="Let visitors switch light/dark" desc="Shows the sun/moon toggle in the navigation bar." checked={th.allow_toggle} onChange={s("allow_toggle")} testId="theme-allow-toggle" />
      </Group>
      <Group title="Accent color" desc="Used for buttons, borders, headings and highlights across the whole site.">
        <div className="flex flex-wrap gap-2">
          {PRESETS.map(([n, c]) => (
            <button key={c} type="button" onClick={() => s("accent")(c)} className={`flex items-center gap-2 rounded-full border px-3 py-1.5 text-xs ${th.accent?.toLowerCase() === c.toLowerCase() ? "ring-2 ring-offset-2 ring-offset-background" : ""}`} style={{ borderColor: c, "--tw-ring-color": c }} data-testid={`theme-preset-${c.slice(1)}`}>
              <span className="h-4 w-4 rounded-full" style={{ background: c }} />{n}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <input type="color" value={th.accent} onChange={(e) => s("accent")(e.target.value)} className="h-11 w-14 cursor-pointer rounded border bg-transparent" data-testid="theme-accent-picker" />
          <Input value={th.accent} onChange={(e) => s("accent")(e.target.value)} className="w-36 font-mono" data-testid="theme-accent-input" />
        </div>
      </Group>
      <Group title="Cinematic background" desc="The dark photo background used on Home, Registration, Login and Help pages.">
        <Toggle label="Use cinematic background" desc="Turn off for plain pages that follow light/dark mode." checked={th.cinematic} onChange={s("cinematic")} testId="theme-cinematic-toggle" />
        <Toggle label="Slow zoom & fade on the home page" checked={th.zoom_animation} onChange={s("zoom_animation")} testId="theme-zoom-toggle" />
        <UploadField label="Background image (leave empty for the default castle)" kind="background" accept="image/png,image/jpeg,image/webp" path={th.bg_path} onChange={s("bg_path")} testId="theme-bg"
          hint="Large landscape photo recommended (at least 1920px wide, max 8MB)."
          preview={<img src={publicFileUrl(th.bg_path)} alt="" className="h-14 w-24 rounded border object-cover" data-testid="theme-bg-preview" />} />
        <div className="space-y-3">
          <Label>Dark overlay strength: {th.overlay}%</Label>
          <Slider min={30} max={98} step={1} value={[th.overlay]} onValueChange={([v]) => s("overlay")(v)} data-testid="theme-overlay-slider" />
        </div>
      </Group>
      <SaveBar onClick={() => save({ theme: th })} busy={busy} testId="theme-save-btn" />
    </div>
  );
};
